














































































































import Vue from 'vue';
import { RequestSession } from '@/interfaces/requestSession';
import { ENDPOINTS, get } from '@/api/mainApi';
import { Donation } from '@/interfaces/donation/donation';
import { isDigitalPayment, isInvoice } from '@/classes/PaymentMethod';
import { Snackbar } from '@/interfaces/presentation/snackbar';
import { Dialog } from '@/interfaces/presentation/dialog';
import { SystemStatus } from '@/interfaces/system/systemStatus';
import { SystemBanner } from '@/interfaces/system/systemBanner';
import { BasaltSystemScope } from '@/enums/basaltSystemScope';
import { stepV1, stepV2 } from "@/enums/donationStepOrder";
import { DonationStepFlowVersion } from '@/enums/donationStepFlowVersion';
import StepperFlowMixin from '@/mixins/donationStepperFlowMixin';
import DonationFlowWrapper from '@/components/flow/DonationFlowWrapper.vue';
import I18n from '@/plugins/i18n';


export default Vue.extend({
  components: {
    DonationFlowWrapper,
  },
  mixins: [StepperFlowMixin],
  data() {
    return {
      definedStep: null,
      multipleDonationTypes: false,
      requestHasExternalAgent: false,
      requestHasOnlyOneCase: false,
      loading: true,
      sessionError: false,
      systemStatus: {
        donationGuideModule: {
          maintenanceMode: false,
          message: '',
        },
        adminModule: {
          maintenanceMode: false,
          message: '',
        },
      } as SystemStatus,
      systemBanners: [] as SystemBanner[],
    };
  },
  computed: {
    steps(): typeof stepV1 | typeof stepV2 {
      return this.donationStepFlowVersion == DonationStepFlowVersion.V1 ? stepV1 : stepV2;
    },
    requestSession(): RequestSession {
      return this.$store.state.requestSession
    },
    donation(): Donation {
      return this.$store.state.donation
    },
    snackbar(): Snackbar {
      return this.$store.state.snackbar
    },
    dialog(): Dialog {
      return this.$store.state.dialog
    },
  },
  async created() {
    const lang =I18n.getUserLanguage();
    this.systemStatus = await this.getSystemStatus();
    await I18n.loadTranslations(I18n.getUserLanguage());
    this.systemBanners = await this.getSystemBanners();
  },
  async mounted() {
    this.loading = true
    if (this.systemStatus.donationGuideModule.maintenanceMode) {
      return
    }

    let requestSession: RequestSession = await this.getRequestSession(false)
    if ((this.getPaymentCodeParam() || !requestSession) && this.getSerialnumberParam() != null) {
      await this.handleDonationFromSerialnumber();
    } else {
      requestSession = await this.getRequestSession(true);

      this.setSessionInStore(requestSession);
      this.multipleDonationTypes = requestSession && requestSession.donationTypes.length > 1;
      this.requestHasOnlyOneCase =
        requestSession &&
        requestSession.donationCases != null &&
        requestSession.donationCases.length == 1;
      this.requestHasExternalAgent = requestSession && requestSession.externalAgent != null;
      if (requestSession && requestSession.paymentResponse) {
        // set donation
        let previousDonation: Donation = await get(
          ENDPOINTS.DONATIONS +
            '/' +
            ENDPOINTS.SERIALNUMBER +
            '/' +
            requestSession.paymentResponse.donationSerialnumber
        );
        if (previousDonation) {
          this.$store.commit('updateDonation', previousDonation);
          if (previousDonation.paymentSpecification.paid) {
            // if payment is paid and show success
            this.definedStep = this.steps.SUCCESS;
          } else {
            // else show payment view
            this.definedStep = this.steps.PAYMENT;
          }
        }
      } else {
        this.definedStep = this.steps.DONATION_TYPE;
      }
    }
    this.handleCustomTheming(requestSession);
    this.loading = false;
  },
  methods: {
    closeSnackbar() {
      this.$store.commit('setSnackbar', { active: false });
    },
    closeDialog() {
      this.$store.commit('setDialog', { active: false });
    },
    dialogActionClick() {
      this.dialog.actionClick();
      this.closeDialog();
    },
    getSerialnumberParam(): string | null {
      const queryString = window.location.search;
      let urlParams = new URLSearchParams(queryString);
      if (urlParams.has('serialnumber')) {
        return urlParams.get('serialnumber');
      }
      return null;
    },
    getPaymentCodeParam(): string | null {
      const queryString = window.location.search;
      let urlParams = new URLSearchParams(queryString);
      if (urlParams.has('paymentCode')) {
        return urlParams.get('paymentCode');
      }
      return null;
    },
    async getRequestSession(handleError: boolean) {
      return await get(ENDPOINTS.SESSIONS_COOKIE_REQUEST, {}, handleError);
    },
    setSessionInStore(requestSession: RequestSession) {
      this.$store.commit('updateRequestSession', requestSession);
    },
    isInvoice(): boolean {
      return isInvoice(this.donation.paymentSpecification.paymentMethod.type);
    },
    isDigitalPayment(): boolean {
      return isDigitalPayment(this.donation.paymentSpecification.paymentMethod.type);
    },
    reloadLocation() {
      location.reload();
    },
    async verifyRequestSessionToken() {
      // makes sure token in our store has not changed from the one in our cookie
      if (!this.getPaymentCodeParam() && this.requestSession && this.requestSession.token) {
        let requestSession: RequestSession = await this.getRequestSession(false);
        if (
          requestSession &&
          requestSession.token &&
          requestSession.token != this.requestSession.token
        ) {
          // if we get a response back and the token does not match we show an error
          this.sessionError = true;
        }
      }
    },
    handleCustomTheming(requestSession: RequestSession) {
      if (requestSession) {
        if (requestSession.primaryColor) {
          this.$vuetify.theme.themes.light.primary = '#' + requestSession.primaryColor;
        }
        if (requestSession.secondaryColor) {
          this.$vuetify.theme.themes.light.secondary = '#' + requestSession.secondaryColor;
        }
        if (requestSession.accentColor) {
          this.$vuetify.theme.themes.light.accent = '#' + requestSession.accentColor;
        }
        if (!!requestSession.hideTaxReductionInfo) {
          this.$store.commit('hideTaxReductionInfo', requestSession.hideTaxReductionInfo);
        }
      }
    },
    async handleDonationFromSerialnumber() {
      let stepSet = false;
      let serialnumber = this.getSerialnumberParam()
      let previousDonation: Donation = await get(ENDPOINTS.DONATIONS + "/" + ENDPOINTS.SERIALNUMBER + "/" + serialnumber)
      if (previousDonation) {
        this.$store.commit('updateDonation', previousDonation)
        if (previousDonation.paymentSpecification.paid) {
          // if payment is paid and show success
          this.definedStep = this.steps.SUCCESS;
          stepSet = true;
        } else {
          let paymentCode = this.getPaymentCodeParam()
          if (paymentCode) {
            this.definedStep = this.steps.PAYMENT_LINK;
            stepSet = true;
          }
          // else show payment view
          if (!stepSet) {
            location.href = '/'
          }
        }
      }
    },
    async getSystemStatus(): Promise<SystemStatus> {
      return await get(ENDPOINTS.SYSTEM_STATUS, {}, false);
    },
    async getSystemBanners(): Promise<Array<SystemBanner>> {
      return await get(
        ENDPOINTS.SYSTEM_BANNERS,
        { scope: BasaltSystemScope.DONATION_GUIDE },
        false
      );
    },
  },
});
